var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { AppClockInternals } from './modules/AppClockInternals';
import { AppClockwork } from './modules/AppClockwork';
import { TickingClock } from '../../../runtime/modules/clock/TickingClock';
export class AppClock {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get appClockInternals() {
        return new AppClockInternals(this);
    }
    get clock_minute() {
        const ticking = new AppClockwork(this, 60000);
        return new TickingClock(ticking);
    }
    get clock_1000() {
        const ticking = new AppClockwork(this, 1000);
        return new TickingClock(ticking);
    }
    get clock_250() {
        const ticking = new AppClockwork(this, 250);
        return new TickingClock(ticking);
    }
    get clock_100() {
        const ticking = new AppClockwork(this, 100);
        return new TickingClock(ticking);
    }
    get clock_frame() {
        const ticking = new AppClockwork(this, 'frame');
        return new TickingClock(ticking);
    }
    get isAppClockPaused() {
        return this.appClockInternals.isAppClockPaused;
    }
    set isAppClockPaused(newPaused) {
        this.appClockInternals.isAppClockPaused = newPaused;
    }
    get currentTime() {
        // in milliseconds
        if (this.appClockInternals.pauseStartAppTime) {
            // paused
            return this.appClockInternals.pauseStartAppTime;
        }
        return new Date().getTime() - this.appClockInternals.delayDueToOldPausesInMilliseconds;
    }
    get currentDate() {
        return new Date(this.currentTime);
    }
    get currentMySqlTimestamp() {
        return new Date().mysqlTimestamp;
    }
}
__decorate([
    memoize
], AppClock.prototype, "appClockInternals", null);
__decorate([
    memoize
], AppClock.prototype, "clock_minute", null);
__decorate([
    memoize
], AppClock.prototype, "clock_1000", null);
__decorate([
    memoize
], AppClock.prototype, "clock_250", null);
__decorate([
    memoize
], AppClock.prototype, "clock_100", null);
__decorate([
    memoize
], AppClock.prototype, "clock_frame", null);
__decorate([
    computed
], AppClock.prototype, "isAppClockPaused", null);
